module.exports = __webpack_public_path__ + "static/silence-c48c0f1f12b88868bdfa5dbe93625773.mp3";